import React, { useEffect, useState } from "react";
import { CiFilter } from "react-icons/ci";
import { IoIosArrowBack } from "react-icons/io";
import { IoCheckmark } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { getRejectAction } from "../../Actions/RejectAction/RejectAction";
import { FaRegEye } from "react-icons/fa";
import { GiReturnArrow } from "react-icons/gi";
import ViewRejectModal from "../../Modal/RejectModal/ViewRejectModal";
import RefuseRejectModal from "../../Modal/RejectModal/RefuseRejectModal";
import LoadingPage from "../Loading/LoadingPage";
import Pagination from "../Pagination";

const RejectPage = () => {
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const getReject = useSelector((state) => state.getReject);
  const { rejects, loading, total } = getReject;

  const [isOpenViewReject, setIsOpenViewRejectModal] = useState(false);
  const [isOpenrRefuseRejectModal, setIsOpenrRefuseRejectModal] =
    useState(false);

  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [indexx, setIndexx] = useState(null);
  const [visitWithReject, setVisitWithReject] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getRejectAction(
        perPage,
        page,
        filter.fullname,
        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        filter.from,
        filter.to
      )
    );
  }, [perPage]);
  const th = [
    {
      label: "Code",
      name: "code",
    },
    {
      label: "full Name",
      name: "fullname",
    },
    {
      label: "Gender",
      name: "gender",
    },
    {
      label: "phone",
      name: "phone",
    },
    {
      label: "birth date",
      name: "birthDate",
    },
  ];
  const [filter, setFilter] = useState({
    fullname: "",
    code: "",
    gender: "",
    phone: "",
    birthDate: "",
    from: "",
    to: "",
  });
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };
  const handleSearch = () => {
    dispatch(
      getRejectAction(
        perPage,
        page,
        filter.fullname,
        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        filter.from,
        filter.to
      )
    );
    setIsOpenFilter(false);
  };
  const handleClearSearch = (name) => {
    const updateFilter = { ...filter };

    updateFilter[name] = "";

    dispatch(
      getRejectAction(
        perPage,
        page,
        updateFilter.fullname,
        updateFilter.code,
        updateFilter.gender,
        updateFilter.phone,
        updateFilter.birthDate
      )
    );
    setFilter(updateFilter);
    setIsOpenFilter(false);
  };
  const onPageChange = (event) => {
    setPage(event.selected);

    dispatch(
      getRejectAction(
        perPage,
        event.selected + 1,
        filter.fullname,
        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        filter.from,
        filter.to
      )
    );
  };
  return (
    <>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="parent">
          <div className="flex justify-between items-center p-2">
            <div>
              <p className="font-bold">Reject</p>
            </div>
            <div className="flex gap-3 items-center">
              <div className="w-full">
                <input
                  type="date"
                  className="input"
                  name="from"
                  value={filter.from}
                  onChange={handleFilterChange}
                />
              </div>
              <div>
                <p>TO</p>
              </div>
              <div className="w-full">
                <input
                  type="date"
                  className="input"
                  name="to"
                  value={filter.to}
                  onChange={handleFilterChange}
                />
              </div>

              <button className="btn-blue py-2 mb-0" onClick={handleSearch}>
                <CiFilter />
              </button>
            </div>
          </div>

          <div className={"parent-table  w-full"}>
            <div className=" overflow-y-auto" style={{ height: "70vh" }}>
              <table className="w-full  overflow-y-auto">
                <thead className="coustm-thead">
                  <tr>
                    <th className="coustm-th">#</th>
                    {th.map((th, index) => {
                      return (
                        <th className="coustm-th relative " key={index}>
                          <div className="flex justify-between items-center">
                            {th.label}
                            <div
                              className="parent-filter"
                              onClick={() => {
                                setIsOpenFilter(!isOpenFilter);
                                setIndexx(index);
                              }}
                            >
                              <CiFilter />
                            </div>
                          </div>
                          {index == indexx && isOpenFilter && (
                            <div className="parent-input-filter ">
                              <input
                                type="text"
                                className="p-2 text-black"
                                name={th.name}
                                onChange={handleFilterChange}
                                value={filter[th.name]}
                                placeholder={th.label}
                              />
                              <div className="fotter-filter mt-2">
                                <button
                                  className="btn-primary px-1.5 py-1 font-bold"
                                  onClick={handleSearch}
                                >
                                  <IoCheckmark />
                                </button>
                                <button
                                  onClick={() => handleClearSearch(th.name)}
                                  className="btn-danger px-1.5 py-1"
                                >
                                  <RxCross2 />
                                </button>
                              </div>
                            </div>
                          )}
                        </th>
                      );
                    })}
                    <th className="coustm-th">Visits </th>
                    <th className="coustm-th">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {rejects?.map((reject, index) => {
                    return (
                      <tr className={"coustm-tr"} key={index}>
                        <td className="coustm-td">{index + 1}</td>
                        <td className="coustm-td">
                          {" "}
                          {reject.patient_info.code}
                        </td>
                        <td className="coustm-td">
                          {" "}
                          {reject.patient_info.fullname}
                        </td>
                        <td className="coustm-td">
                          {" "}
                          {reject.patient_info.gender}
                        </td>
                        <td className="coustm-td">
                          {" "}
                          {reject.patient_info.phone}
                        </td>
                        <td className="coustm-td">
                          {" "}
                          {reject.patient_info.birth_date}
                        </td>
                        <td className="coustm-td text-red-600 underline text-lg font-bold text-center">
                          {" "}
                          {reject.count_visits_with_reject}
                        </td>
                        <td className="coustm-td flex justify-center">
                          <div className="flex gap-2 items-center">
                            <button
                              title="View"
                              className="btn-primary "
                              onClick={() => {
                                setVisitWithReject(reject.visits_with_reject);
                                setIsOpenViewRejectModal(true);
                              }}
                            >
                              <FaRegEye />
                            </button>
                            <button
                              onClick={() => {
                                setVisitWithReject(reject.visits_with_reject);
                                setIsOpenrRefuseRejectModal(true);
                              }}
                              title="Return"
                              className="btn-warning "
                            >
                              <GiReturnArrow />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {total > 0 ? (
            <Pagination
              total={total}
              page={page}
              perPage={perPage}
              onPageChange={onPageChange}
              setPerPage={setPerPage}
            />
          ) : (
            ""
          )}
        </div>
      )}
      {isOpenViewReject && (
        <ViewRejectModal
          closeModal={() => setIsOpenViewRejectModal(false)}
          visits={visitWithReject}
        />
      )}
      {isOpenrRefuseRejectModal && (
        <RefuseRejectModal
          closeModal={() => setIsOpenrRefuseRejectModal(false)}
          visits={visitWithReject}
        />
      )}
    </>
  );
};

export default RejectPage;
